<template>
  <div
    @dblclick="$emit('dblClickEmptyArea')"
    id="gantt_test"
    ref="timesheetgantt"
    :class="this.colorClass"
    class="w-100"
  />
</template>

<script>
import "@/libs/dhtmlx-gantt/codebase/dhtmlxgantt";
// import '@/libs/dhtmlx-gantt/codebase/ext/dhtmlxgantt_smart_rendering'
// import {gantt} from 'dhtmlx-gantt';
import moment from "moment";
import { mapState, mapMutations } from "vuex";
import { debounce, memoize } from "lodash";
const events = [];
const tg = Gantt.getGanttInstance();
export default {
  name: "TimeSheetGantt",
  props: {
    ganttView: {
      type: String,
      default: "5_mins"
    },
    ganttDay: {
      type: String,
      default: "full-week"
    },
    ganttComment: {
      type: String,
      default: "task-title"
    },
    ganttZoom: {
      type: String,
      default: "few"
    },
    colorClass: {
      type: String,
      default: ""
    },

    showAssignedTo: {
      type: Boolean,
      default: false
    },
    showBilling: {
      type: Boolean,
      default: true
    },
    currency: {
      type: Object,
      default: { value: "AUD", label: "Australia", symbol: "$" }
    },
    currentDate: {
      type: String
    },
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] };
      }
    }
  },
  data() {
    return {
      commentMode: "task-title"
    };
  },

  watch: {
    tasks(val) {
      this.initGantt();
    },
    ganttRender(val) {
      this.initGantt();
    },
    showBilling() {
      this.initGantt();
    },
    currency() {
      tg.render();
    },
    ganttView() {
      this.initGantt();
    },
    ganttDay() {
      this.initGantt();
    },
    ganttComment(val) {
      this.commentMode = val;
      this.initGantt();
    },
    ganttZoom() {
      this.initGantt();
    },

    currentDate(val) {
      var newStartDate = moment(val).toDate(),
        m = newStartDate.getMonth(),
        d = newStartDate.getDate(),
        y = newStartDate.getFullYear();
      console.log("om next new month is:" + m);
      tg.config.start_date = new Date(y, m, d, 7, 0);
      tg.config.end_date = new Date(y, m, d, 20, 0);
      tg.render();
      // tg.config.end_date = setEndDate;
      console.log("tg", new Date(y, m, d, 7, 0));
      //this.initGantt()
    }
  },

  methods: {
    ...mapMutations(["setLoading"]),

    onAssignedToUserIconClicked(id, userId, event) {
      this.$emit("assigned-to-user-clicked", id, userId);
    },

    initGantt() {
      this.setLoading(true);
      this.resetGantt();

      tg.plugins({
        multiselect: true,
        tooltip: true
      });

      console.log("init timesheet");
      this.initTimesheetGantt();
      events.push(
        tg.attachEvent("onGridResize", function(old_width, new_width) {
          tg.config.show_grid = false;
          tg.render();
        })
      );

      events.push(
        tg.attachEvent("onTaskSelected", id => {
          let task = tg.getTask(id);
          this.$emit("task-selected", task);
        })
      );

      events.push(
        tg.attachEvent("onAfterTaskAdd", (id, task) => {
          this.$emit("task-updated", id, "inserted", task);
          task.progress = task.progress || 0;
          if (tg.getSelectedId() == id) {
            this.$emit("task-selected", task);
          }
        })
      );

      tg.attachEvent("onAfterTaskUpdate", (id, task) => {
        this.$emit("task-updated", id, "updated", task);
      });

      events.push(
        tg.attachEvent("onAfterTaskDelete", id => {
          this.$emit("task-updated", id, "deleted");
          if (!tg.getSelectedId()) {
            this.$emit("task-selected", null);
          }
        })
      );

      events.push(
        tg.attachEvent("onAfterLinkAdd", (id, link) => {
          this.$emit("link-updated", id, "inserted", link);
        })
      );
      events.push(
        tg.attachEvent("onAfterLinkUpdate", (id, link) => {
          this.$emit("link-updated", id, "updated", link);
        })
      );

      events.push(
        tg.attachEvent("onAfterLinkDelete", (id, link) => {
          this.$emit("link-updated", id, "deleted");
        })
      );

      events.push(
        tg.attachEvent("onAfterTaskDrag", (id, mode, e) => {
          //   debounce((id, mode, e) => {
          //   //console.log("dragged", id, mode, e);
          //   this.$emit("task-dragged", id, e);
          //   return true;
          // }, 1000)
          let task = tg.getTask(id);

          this.$emit("task-dragged", id, task);
        })
      );

      events.push(
        tg.attachEvent("onTaskDblClick", (id, event) => {
          let task = tg.getTask(id);
          this.$emit("task-dbl-click", id, event, task);
          return false;
        })
      );

      events.push(
        tg.attachEvent("onTaskClick", (id, event) => {
          //console.log("link", id, event);
          if (id) {
            let task = tg.getTask(id);
            if (event.target.classList.contains("taskLink")) {
              this.$emit("task-link-clicked", id);
              console.log("link clicked ");
            }
          }
          return true;
        })
      );

      let self = this;
      events.push(
        tg.attachEvent("onGanttRender", (id, event) => {
          self.setLoading(false);
        })
      );
      //set scale
      this.setScaleConfig(this.ganttView);
      this.setzoomlevelheightconfig(this.ganttZoom);
      let subtractDays = 0;
      if (this.ganttDay == "work-days") {
        tg.ignore_time = function(date) {
          if (date.getDay() == 0 || date.getDay() == 6) {
            return true;
          }

          return false;
        };
        subtractDays = 15;
      } else if (this.ganttDay == "full-week") {
        tg.ignore_time = function(date) {
          return false;
        };
        subtractDays = 11;
      }

      if (this.ganttView == "month") {
        subtractDays = 40;
      } else if (this.ganttView == "year") {
        subtractDays = 98;
      }

      tg.init(this.$refs.timesheetgantt);

      tg.ext.tooltips.tooltipFor({
        selector: ".taskLink",
        html: event => {
          if (tg.config.touch && !tg.config.touch_tooltip) {
            return;
          }

          const targetTaskId = tg.locate(event);
          if (tg.isTaskExists(targetTaskId)) {
            const task = tg.getTask(targetTaskId);
            //console.log(task)
            return "Bracket { " + task.project.name + " }";
          }
          return null;
        },
        global: true
      });

      tg.ext.tooltips.tooltipFor({
        selector: ".gantt_task_content",
        html: event => {
          if (tg.config.touch && !tg.config.touch_tooltip) {
            return;
          }

          const targetTaskId = tg.locate(event);
          if (tg.isTaskExists(targetTaskId)) {
            const task = tg.getTask(targetTaskId);
            return task.description || "Last comment not found";
          }
          return null;
        },
        global: true
      });

      tg.clearAll();
      tg.parse(this.tasks);

      var scrollX = tg.posFromDate(
        moment()
          .subtract(subtractDays, "d")
          .toDate()
      );
      tg.scrollTo(scrollX, 0);
      self.setLoading(false);
    },

    initTimesheetGantt() {
      tg.config.columns = [
        {
          label: "",
          text: "Test",

          tree: true,
          align: "center",
          resize: true,
          hide: true
        }
      ];

      // tg.config.show_grid = true;
      // removes non-working time from calculations
      tg.config.min_duration = 1 * 60 * 1000;
      tg.config.duration_unit = "minute";
      // removes non-working time from calculations
      tg.config.work_time = true;
      // hides non-working time in the chart
      // tg.config.skip_off_time = false;
      // tg.config.correct_work_time = true;
      //changes the working time of working days
      tg.setWorkTime({ hours: [7, 24] });

      tg.config.details_on_dblclick = false; // double click false to remove lightbox
      tg.config.static_background = false;
      tg.config.task_height = 45;
      tg.config.scale_height = 55;
      tg.config.drag_links = false;
      tg.config.grid_resize = true;
      tg.config.drag_progress = false;
      // tg.config.grid_width = 1;
      tg.config.row_height = 56;
      // tg.config.min_grid_column_width = false;
      // tg.config.keep_grid_width = false;
      tg.config.scale_unit = "day";
      tg.config.date_scale = "%D, %F %d, %Y";
      //Limit time
      // var task = tg.getTask(1);
      // if(tg.isSplitTask(task)){
      //     console.log('splt is done');

      // }
      // task.render = "split";
      // tg.render();

      tg.config.start_date = moment(this.currentDate)
        .set({ hours: 7, minutes: 0 })
        .toDate();
      tg.config.end_date = moment(this.currentDate)
        .set({ hours: 20, minutes: 0 })
        .toDate();

      //Highlighting Days on weekend, alternative hour with border
      var daysStyle = function(date) {
        var return_class,
          day = tg.date.date_to_str("%D"),
          hour = tg.date.date_to_str("%h");
        if (day(date) == "Sun" || day(date) == "Sat") {
          return_class = " weekend";
        }
        if (hour(date) % 2 != 0) {
          return_class += " alternative";
        }
        return_class += " blur borderRight";
        return return_class;
      };

      this.borderStyle1 = function(date) {
        var return_class,
          hour = date.getHours(),
          minute = date.getMinutes();
        // var dateToStr = tg.date.date_to_str("%i");
        // if (dateToStr(date)) return "secondBlur borderRight";
        if (minute == 55) {
          // return "borderRight";
          return_class = "borderRight";
        }
        if (hour % 2 != 0) {
          return_class += " alternative";
        } else {
          return_class += "";
        }
        return_class += " font-sm timeline-number";
        return return_class;
      };
      this.borderStyle2 = function(date) {
        var return_class,
          hour = date.getHours(),
          minute = date.getMinutes();
        // var dateToStr = tg.date.date_to_str("%i");
        // if (dateToStr(date)) return "secondBlur borderRight";
        if (minute == 50) {
          // return "borderRight";
          return_class = "borderRight";
        }
        if (hour % 2 != 0) {
          return_class += " alternative";
        } else {
          return_class += "";
        }
        return_class += " font-sm timeline-number";
        return return_class;
      };
      this.borderStyle3 = function(date) {
        // var dateToStr = tg.date.date_to_str("%i");
        // if (dateToStr(date)) return "secondBlur borderRight";
        var return_class,
          hour = date.getHours(),
          minute = date.getMinutes();
        if (minute == 45) {
          // return "borderRight";
          return_class = "borderRight 45";
        }
        if (hour % 2 != 0) {
          return_class += " alternative";
        } else {
          return_class += "";
        }
        return_class += " font-sm timeline-number";
        return return_class;
      };

      //Mobile versions
      var win_width = $(window).width();
      var new_width = win_width - 60 - 8;
      var new_width_factor = new_width / 18;
      if (win_width < 768) {
        tg.config.min_column_width = new_width_factor;
        console.log("mobile windows width:" + new_width);
        console.log("mobile width:" + new_width_factor);
        // var checkedBox = document.getElementsByName('timesheetPinch')[2].value;
        // console.log('checkBox is' + checkedBox);
        // document.getElementsByName('timesheetPinch')[1].value.checked = true;
        $("input[name='timesheetPinch']").each(function(i) {
          if ($(this).val() == "3") {
            console.log("3rd one");
            $(this).prop("checked", true);
          }
        });
        tg.config.subscales = [
          {
            unit: "hour",
            step: 1,
            // date: dayScaleTemplate
            date: "%g %a",
            css: daysStyle
          },
          { unit: "minute", step: 15, date: "%i", css: this.borderStyle3 }
        ];
      } else {
        tg.config.min_column_width = 18;
        tg.config.subscales = [
          {
            unit: "hour",
            step: 1,
            // date: dayScaleTemplate
            date: "%g %a",
            css: daysStyle
          },
          { unit: "minute", step: 5, date: "%i", css: this.borderStyle1 }
        ];
      }
      tg.templates.task_text = function(start, end, task) {
        return null;
      };

      // tg.templates.leftside_text = function(start, end, task) {
      //   return "<b>Priority: </b>" + task.priority;
      // };

      // tg.config.subscales.work_time = true;
      //changes the working time of working days from [8,17] to [9,18]
      // tg.setWorkTime({ hours:[7,18] });
      //changes the working time for Fridays and Saturdays from [8,17] to [8,12]
      // tg.setWorkTime({day : 5, hours : [8,12]});
      // tg.setWorkTime({day : 6, hours : [8,12]});
      // add right side text (My task # hashtag hidden)

      tg.templates.tooltip_text = function(start, end, task) {
        // console.log(task, self.commentMode)
        let txt = `
              <b>Task:</b> ${task.name}<br/>
              <b>Project Name:</b> ${task.project && task.project.name}<br/>
              <b>Total Time:</b> ${task.project && task.total_time}<br/>
              <b>Description:</b> ${task.project && task.description}<br/>
              `;
        return txt;
      };

      tg.templates.rightside_text = function(start, end, task) {
        // console.log('start date:' + start);
        // console.log('task start date:' + task.start_date);

        var task_return,
          arrowRight = "",
          // <span class="mr-1"></span>
          taskTitle =
            '<span class="taskLink"  data-original-title="' +
            task.project.name +
            '">' +
            task.name +
            "</span>";

        task_return = arrowRight;
        task_return +=
          ' <a class="taskLink ml-1" data-transition="slideleft" style="cursor:pointer;">' +
          taskTitle +
          " </a>";

        return task_return;
      };

      var today_date = new Date();
      // var today_date = new Date();
      var lastday = function(y, m) {
        // console.log(date.getFullYear());
        return new Date(y, m + 1, 0).getDate();
      };

      // tg.templates.timeline_cell_class = function(item, date) {
      //   // console.log('date show:' + date);
      //   // console.log(today_date.getDate() +'<'+ date.getDate())
      //   var return_class,
      //     hour = date.getHours(),
      //     minute = date.getMinutes();
      //   if (
      //     date.getDate() == today_date.getDate() &&
      //     date.getMonth() == today_date.getMonth() &&
      //     date.getFullYear() == today_date.getFullYear()
      //   ) {
      //     return_class = "today";
      //   }
      //   if (date.getDay() == 0 || date.getDay() == 6) {
      //     return_class += " weekend";
      //   }
      //   if (date.getDate() == lastday(date.getFullYear(), date.getMonth())) {
      //     // console.log('asdas');
      //     return_class += " lastDay";
      //   }

      //   if (date.getDate() == lastday(date.getMinutes())) {
      //     // console.log('asdas');
      //     return_class += " lastMinute";
      //   }
      //   if (win_width < 768 && minute == 45) {
      //     return_class = " borderRight";
      //   } else if (minute == 55) {
      //     return_class = " borderRight";
      //   }
      //   // var dateToStr = tg.date.date_to_str("%i");
      //   // if (dateToStr(date)) return "secondBlur borderRight";
      //   // if (minute == 55) {
      //   //     // return "borderRight";
      //   //     return_class = 'borderRight';
      //   // }
      //   if (hour % 2 != 0) {
      //     return_class += " alternative";
      //   } else {
      //     return_class += "";
      //   }

      //   return return_class;
      //   // if()
      //   // return (lastday(date.getFullYear(),date.getMonth()));
      // };

      tg.templates.scale_cell_class = function(date) {
        return "left-center";
      };
    },

    setScaleConfig(value) {
      switch (value) {
        case "mins_5":
          tg.config.scale_unit = "day";
          tg.config.step = 1;
          tg.config.date_scale = "%D, %F %d, %Y";
          tg.config.date_grid = "%H:%i";
          tg.config.duration_unit = "minute";
          // tg.config.grid_resize = true;
          tg.config.subscales = [
            {
              unit: "hour",
              step: 1,
              // date: dayScaleTemplate
              date: "%g %a",
              css: daysStyle
            },
            { unit: "minute", step: 5, date: "%i", css: this.borderStyle1 }
          ];
          if (win_width < 768) {
            tg.config.min_column_width = new_width_factor;
          } else {
            tg.config.min_column_width = 18;
          }
          tg.templates.timeline_cell_class = function(item, date) {
            var return_class,
              hour = date.getHours(),
              minute = date.getMinutes();
            // var dateToStr = tg.date.date_to_str("%i");
            // if (dateToStr(date)) return "secondBlur borderRight";
            if (minute == 55) {
              // return "borderRight";
              return_class = "borderRight";
            }
            if (hour % 2 != 0) {
              return_class += " alternative";
            } else {
              return_class += "";
            }

            return return_class;
          };
          // $('body').removeClass('MonthView');
          // $('body').removeClass('YearView');
          tg.templates.date_scale = null;
          break;
        case "mins_10":
          tg.config.scale_unit = "day";
          tg.config.step = 1;
          tg.config.date_scale = "%D, %F %d, %Y";
          tg.config.date_grid = "%H:%i";
          tg.config.duration_unit = "minute";
          // tg.config.grid_resize = true;
          tg.config.subscales = [
            {
              unit: "hour",
              step: 1,
              // date: dayScaleTemplate
              date: "%g %a",
              css: daysStyle
            },
            { unit: "minute", step: 10, date: "%i", css: this.borderStyle2 }
          ];
          tg.templates.timeline_cell_class = function(item, date) {
            var return_class,
              hour = date.getHours(),
              minute = date.getMinutes();
            // var dateToStr = tg.date.date_to_str("%i");
            // if (dateToStr(date)) return "secondBlur borderRight";
            if (minute == 50) {
              // return "borderRight";
              return_class = "borderRight";
            }
            if (hour % 2 != 0) {
              return_class += " alternative";
            } else {
              return_class += "";
            }

            return return_class;
          };
          if (win_width < 768) {
            tg.config.min_column_width = new_width_factor + 3;
          } else {
            tg.config.min_column_width = 18;
          }
          // $('body').removeClass('MonthView');
          // $('body').removeClass('YearView');
          tg.templates.date_scale = null;
          break;
        case "mins_15":
          tg.config.scale_unit = "day";
          tg.config.step = 1;
          tg.config.date_scale = "%D, %F %d, %Y";
          tg.config.date_grid = "%H:%i";
          tg.config.duration_unit = "minute";
          // tg.config.grid_resize = true;
          tg.config.subscales = [
            {
              unit: "hour",
              step: 1,
              // date: dayScaleTemplate
              date: "%g %a",
              css: daysStyle
            },
            { unit: "minute", step: 15, date: "%i", css: this.borderStyle3 }
          ];
          tg.templates.timeline_cell_class = function(item, date) {
            var return_class,
              hour = date.getHours(),
              minute = date.getMinutes();
            // var dateToStr = tg.date.date_to_str("%i");
            // if (dateToStr(date)) return "secondBlur borderRight";
            if (minute == 45) {
              // return "borderRight";
              return_class = "borderRight";
            }
            if (hour % 2 != 0) {
              return_class += " alternative";
            } else {
              return_class += "";
            }

            return return_class;
          };
          if (win_width < 768) {
            tg.config.min_column_width = new_width_factor + 5;
          } else {
            tg.config.min_column_width = 30;
          }
          // $('body').removeClass('MonthView');
          // $('body').removeClass('YearView');
          tg.templates.date_scale = null;

          break;
        case "day": // day
          // alert('day');

          tg.config.scale_unit = "month";
          tg.config.step = 1;
          tg.config.date_scale = "%F %Y";
          var daysStyle = function(date) {
            return "";
          };
          tg.config.subscales = [
            {
              unit: "day",
              step: 1,
              date: "%j"
            }
          ];

          tg.config.min_column_width = 60;
          var win_width = $(window).width();

          var new_width = win_width - 60 - 8;
          var new_width_factor = new_width / 7;
          if (win_width < 768) {
            tg.config.min_column_width = new_width_factor;
          } else {
            tg.config.min_column_width = 60;
          }
          $("body").removeClass("MonthView");
          $("body").removeClass("YearView");
          tg.templates.date_scale = null;

          break;
        case "week": // week
          var weekScaleTemplate = function(date) {
            var dateToStr = tg.date.date_to_str("%j %M");
            var endDate = tg.date.add(tg.date.add(date, 1, "week"), -1, "day");
            return dateToStr(date) + " - " + dateToStr(endDate);
          };

          tg.config.scale_unit = "week";
          tg.config.step = 1;
          tg.templates.date_scale = weekScaleTemplate;
          tg.config.subscales = [
            {
              unit: "day",
              step: 1,
              date: "%D"
            }
          ];

          var win_width = $(window).width();
          // var gantt_grid = $('.gantt_grid').width();
          var new_width = win_width - 8;
          var new_width_factor = new_width / 7;

          // tg.config.min_column_width = new_width_factor;
          if (win_width < 768) {
            tg.config.min_column_width = new_width_factor;
          } else {
            tg.config.min_column_width = 60;
          }

          // tg.config.scale_height = 62;

          // $('.c-gantt--viewbutton span').text('Weeks');
          $("body").removeClass("MonthView");
          $("body").removeClass("YearView");

          break;
        case "month": // month
          // alert('month');
          var today_date = new Date();
          tg.config.scale_unit = "month";
          tg.config.step = 1;
          tg.config.date_scale = "%F %Y";
          var weekScaleTemplate = function(date) {
            var dateToStr = tg.date.date_to_str("%d %M");
            var endDate = tg.date.add(tg.date.add(date, 1, "week"), -3, "day");
            return dateToStr(date) + " - " + dateToStr(endDate);
          };
          var daysStyle = function(date) {
            var dateToStr = tg.date.date_to_str("%D");
            if (dateToStr(date) == "Sun" || dateToStr(date) == "Sat")
              return "weekend";

            if (
              date.getDate() == today_date.getDate() &&
              date.getMonth() == today_date.getMonth() &&
              date.getFullYear() == today_date.getFullYear()
            ) {
              return "today";
            }

            return "";
          };
          tg.config.subscales = [
            {
              unit: "week",
              step: 1,
              template: weekScaleTemplate
            },
            { unit: "day", step: 1, date: "%D", css: daysStyle }
          ];
          tg.templates.date_scale = null;
          var win_width = $(window).width();
          // var gantt_grid = $('.gantt_grid').width();
          var new_width = win_width;
          var new_width_factor = new_width / 20;
          // console.log(gantt_grid);
          console.log(new_width_factor);
          if (win_width < 768) {
            tg.config.min_column_width = new_width_factor;
          } else {
            tg.config.min_column_width = 20;
          }
          $("body").addClass("MonthView");
          $("body").removeClass("YearView");
          // tg.config.min_column_width = new_width_factor;
          // tg.config.scale_height = 62;

          // $('.c-gantt--viewbutton span').text('Months');
          break;
        case "year": //  year if needed
          tg.config.scale_unit = "year";
          tg.config.step = 1;
          tg.config.date_scale = "%Y";
          tg.config.min_column_width = 7;
          // tg.config.template: monthScaleTemplate;
          // tg.config.scale_height = 90;
          var daysStyle = function(date) {
            var dateToStr = tg.date.date_to_str("%D");
            if (dateToStr(date) == "Sun" || dateToStr(date) == "Sat")
              return "weekend";
            return "";
          };
          var monthScaleTemplate = function(date) {
            var dateToStr = tg.date.date_to_str("%M");
            var endDate = tg.date.add(date, 2, "month");
            return dateToStr(date) + " - " + dateToStr(endDate);
          };

          tg.config.subscales = [
            // {unit: "month", step: 3, template: monthScaleTemplate},
            {
              unit: "month",
              step: 1,
              date: "%F"
            },
            { unit: "day", step: 1, date: "%D", css: daysStyle }
          ];
          tg.templates.date_scale = null;

          $("body").removeClass("MonthView");
          $("body").addClass("YearView");

          break;
      }
    },

    resetGantt() {
      tg.clearAll();
      while (events.length) {
        const ev = events.pop();
        //console.log(ev, "Detachhed")
        tg.detachEvent(ev);
      }
    },

    setzoomlevelheightconfig(value) {
      switch (value) {
        case "few":
          // alert('asdsad');
          $("body").addClass("zoomlevel-1");
          $("body").removeClass("zoomlevel-2");
          $("body").removeClass("zoomlevel-3");
          console.log("setzoomlevelheightconfig 1");
          tg.config.task_height = 45;
          tg.config.scale_height = 55;
          tg.config.grid_width = 40;
          tg.config.row_height = 55;
          // tg.config.row_height = 56;

          console.log(tg.config.grid_width);
          tg.config.show_grid = false;

          break;

        case "many":
          $("body").addClass("zoomlevel-2");
          $("body").removeClass("zoomlevel-3");
          $("body").removeClass("zoomlevel-1");
          tg.config.task_height = 28;
          tg.config.scale_height = 55;
          tg.config.row_height = 38;
          tg.config.grid_width = 40;
          console.log(tg.config.grid_width);
          tg.config.show_grid = false;

          break;

        // $('gantt_here .gantt_grid').hide();
      }
    }
  },

  computed: {
    ...mapState(["ganttRender"]),

    ...mapState("user", ["profile"])
  },
  created() {
    //this.setLoading(true)
  },
  mounted() {
    console.log("gantt mounted", this.ganttView.includes("mins"));
    this.initGantt();

    let self = this;
    //this.setLoading(false)

    // $("body").on("click", ".taskLink", function(event) {
    //   console.log("sssssss", $(this).attr("data-value"));
    //   let id = $(this).attr("data-value");
    //   self.onTaskLinkClicked(id, event);
    // });
  },

  beforeDestroy() {
    this.resetGantt();
  }
};
</script>
